import type { SessionUser } from '@/types/auth'

const SESSION_KEY = 'zsj-admin-session'

function isSession(value: unknown): value is SessionUser {
  if (!value || typeof value !== 'object') return false
  const candidate = value as Partial<SessionUser>
  return (
    (typeof candidate.id === 'string' || typeof candidate.id === 'number') &&
    typeof candidate.name === 'string' &&
    typeof candidate.token === 'string' &&
    candidate.token.length > 0 &&
    Array.isArray(candidate.permissions)
  )
}

export function readSession(): SessionUser | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const parsed: unknown = JSON.parse(raw)
    if (isSession(parsed)) return parsed
  } catch {
    // Invalid browser state is treated as a signed-out session.
  }
  clearSession()
  return null
}

export function writeSession(session: SessionUser): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY)
}
